import React,{useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {InputLabel,FormControl,Select as MaterialSelect  ,Box ,TextField
  ,RadioGroup,Radio, Grid, Typography, FormLabel, FormControlLabel} from '@material-ui/core';
import axios from 'axios';
import qs from 'qs';
import { useHistory } from "react-router-dom";
import {toast} from "react-toastify";
import {ErrorGeneral, llamaApiCargaToken, llamadaApiToken} from "../../funciones/ClienteAxios";
import Modal from '../../Generales/ModalTam';
import Rating from '@material-ui/lab/Rating';
import {DateTimePicker, MuiPickersUtilsProvider, TimePicker} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns'; // choose your lib
import esLocale from "date-fns/locale/es";
import moment from 'moment';
const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
        width: '20ch',
      }, 
      formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
      },
      selectEmpty: {
        marginTop: theme.spacing(2),
      },
      Textnumero: {
        width: 5+"px",
      },
      formControlFull: {
        //margin: theme.spacing(1),
        //minWidth: 120,
        width:5+"rem"
      },
      margin: {
        margin: theme.spacing(1),
      },
    },
  }));

const NuevaBitacora = ({modalAbierto,setModalAbierto,titulo,regisMaquinaria,funcionActuliza}) => {
  let history = useHistory();
  const classes = useStyles();
  const source = axios.CancelToken.source(); 
  const idusu = localStorage.getItem('UsuId');
  const [espera,setEspera]=useState(false);
  const [mensaje, setMensaje] = useState('');
  const [tipoAdvertencia, setTipoAdvertencia] = useState('success');
  const [aviso, setAviso] = useState(false); 
  const [btnDesact, setBtnDesact] = useState(false); 
  const [radioTipo, setRadioTipo] = useState("1"); 
  const [nvActividad,guardarNvActividad]= useState({Orden:0, Descripcion:'',Marca:'',Unidad:'', Cantidad:""});  
  const {Orden, Descripcion,Marca,Unidad, Cantidad}=nvActividad      
  const [listRefaccion, setListRefaccion] = useState([])    
  const [listUnidad, setListUnidad] = useState([])  
  const [fechas,setFechas]=useState({inicio:new Date() ,final:new Date()});
  const {inicio} =fechas
  React.useEffect(()=>{           
    guardarNvActividad({
      ...nvActividad, Orden:regisMaquinaria.Id
    })                     
   
    getListUnidad()
 
    return ()=> {
      source.cancel();
    }     
    // eslint-disable-next-line react-hooks/exhaustive-deps	
  },[]);

  

 const getListUnidad = () => {
    const data = qs.stringify({
      Usuario:idusu,
      ip:"172.0.0.0",
      idDispositivo: '987gyubjhkkjh'
    });
    const url = "/maquinaria/combustible/unidad";

    function respuesta(aux) {
      if (aux[0].Id!==-1) 
      {                  
        setListUnidad(aux);                                      
      }         
    }
    llamaApiCargaToken(data, url,respuesta,ErrorGeneral,setEspera,history,source);
  }; 

  const registrarNActividad=(FCaptura)=>{            
    const auxFiltro = listUnidad.filter((uni)=>uni.Id === parseInt(Unidad))     
    const data = qs.stringify({
      Llave:Orden,
      Usuario:idusu,
      FCaptura:FCaptura,
      Unidad:auxFiltro[0].Descr,
      Cantidad:Cantidad,
      Operador:1,
      Lat:0.0,
      Lon:0.0,
      Dir:"",
      Status:1,            
      Nota:Descripcion,
      ip:"172.2.0.0",      
      idDispositivo:'8978yuhjnfrsdsd'
    });
    const url = "/maquinaria/combustible/new-edit";
  
    function respuesta(aux) {
      if (aux.respuesta==1) 
      { //console.log(aux);
        let mensaje='Se registro correctamente'
        setTipoAdvertencia("success")      
        setMensaje(mensaje);
        setAviso(true)     
        toast.success(mensaje, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });       
        funcionActuliza(Orden)
        setModalAbierto(false)            
      }   
    }
    llamaApiCargaToken(data, url,respuesta,ErrorGeneral,setEspera,history,source);     
  }

  const onChange = e =>
  { let expNopermitida = new RegExp('[#_:$!%-({})/*=?|]');
    let expMenos = new RegExp('-');
    let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[A-Za-z0-9]');
    if ((expCadena.test(e.target.value)&&!expNopermitida.test(e.target.value)&&!expMenos.test(e.target.value)&&
        !expMas.test(e.target.value) )||e.target.value===' '||e.target.value==='') 
    {
    
      guardarNvActividad({
        ...nvActividad,
        [e.target.name] : e.target.value  
      })
      if (aviso) 
      {
        setMensaje('');
        setAviso(false);
      }
    }
  };

  const onChangeDesc = e =>
  {      
    guardarNvActividad({
      ...nvActividad,
      [e.target.name] : e.target.value  
    })
    if (aviso) 
    {
      setMensaje('');
      setAviso(false);
    }    
  };

  const onChangeSelect = e =>
  {
  
    guardarNvActividad({
      ...nvActividad,
      [e.target.name] : e.target.value  
    })
  };

  const onChangeNum = e =>
  { let expNopermitida = new RegExp('[#A-Za-z_:$!%-({})/*=?|]');
    let expMenos = new RegExp('-');
    let expMas = new RegExp('[+]');     
    let expCadena = new RegExp('[0-9]');
    if (expCadena.test(e.target.value)&&!expNopermitida.test(e.target.value)&&!expMenos.test(e.target.value)&&
        !expMas.test(e.target.value)||e.target.value===' '||e.target.value==='') 
    {  
      guardarNvActividad({
        ...nvActividad,
        [e.target.name] : e.target.value  
      })
      if (aviso) 
      {
        setMensaje('');
        setAviso(false);
      }
    }
  };
 
    const guardarInicio = auxfecha =>
  {
    setFechas({
      ...fechas,
      inicio : auxfecha  
    })
  };

 
  const validaDatos=(valor, mensaje)=>{
    let respuesta=false    
    if (valor!= null && valor!= '' && valor!= '0' && valor!== 0 ) 
    { respuesta=true     
    }
    else
    { setTipoAdvertencia("warning")    
      setMensaje(mensaje);
      setAviso(true)     
    }
    return respuesta
  }

   function valNumero(auxNumero,auxCampo) {
    let valida=false    
    if (typeof parseInt(auxNumero) === 'number') 
    {
      if (parseInt(auxNumero) ==0) 
      {
        valida=true
      }  
      else{
        if (parseInt(auxNumero) >0) 
        {  
          valida=true
        } 
      }
    }
    if (!valida) {
      setTipoAdvertencia("warning")
      let mensaje="Llenar campo "+auxCampo            
      setMensaje(mensaje);
      setAviso(true)  
    }
    return valida
  }

  const guardarDatos = () => 
  {
    let auxFecha=moment(inicio).format("YYYY-MM-DDTHH:mm:ss")
    if ( validaDatos(Unidad,"Seleccionar Unidad") && 
      validaDatos(Cantidad, "Llenar campo de Cantidad.") && valNumero(Cantidad, "Cantidad") ) 
    {   registrarNActividad(auxFecha)                                   
    }                                           
  };
 
  const fecha=() =>{
    return(  
    <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>                                                          
      <DateTimePicker
        label="Hora" size={"small"} ampm={false}
        value={inicio} style={{width:10+'rem'}}
        onChange={guardarInicio}
        //helperText="Hora"
        minDate="2017-03-14" maxDate={new Date()}
        format="dd/MM/yyyy HH:mm"
        cancelLabel={"Cancelar"} okLabel="Seleccionar"       
      />                          
    </MuiPickersUtilsProvider>)
  }

  return ( 
  <Modal
    titulo={titulo} modalAbierto={modalAbierto}
    setModalAbierto={setModalAbierto} guardarDatos={guardarDatos}
    mensaje={mensaje} tipoAdvertencia={tipoAdvertencia}
    aviso={aviso} setAviso={setAviso} espera={espera} 
    setEspera={setEspera}  tamanio={"sm"} btnDesact={btnDesact}
  >
    <form className={classes.root} noValidate autoComplete="off" fullWidth style={{width:30+'rem'}} >    
      {fecha()}                                   
      <Box display="flex" flexDirection="row">          
        {listUnidad.length !==0 ?
        <Box mr={1}>
        <FormControl className={classes.formControl} size="small" style={{width:10+'rem' }}>
          <InputLabel htmlFor="age-native-simple">Unidad</InputLabel>
          <MaterialSelect style={{width: 10+"rem",borderRadius:3+'px'}} 
            native value={Unidad}   
            onChange={onChangeSelect}
            inputProps={{ name: 'Unidad', id: 'Unidad', }}            
          >
            <option aria-label="None" value="" />      
            {listUnidad.map((row) => (
             row.Id!==0&& <option value={row.Id}>{row.Descr}</option>
            ))}   
          </MaterialSelect>
        </FormControl>  
        </Box>
        :null}    
        <FormControl component="fieldset" style={{width:12+'rem', marginTop:".2rem"}}>    
          <TextField id="Cantidad-TextArea" name="Cantidad" //rows="5" cols="100"
            label="Cantidad" style={{width: 12+"rem",borderRadius:3+'px'}} 
            variant='outlined' size='small'
            value={Cantidad} onChange={onChangeNum} />          
        </FormControl>    
      </Box> 
     
      <Box>
        <Typography component="p" variant="body2" color='primary' 
          style={{margin:0,marginLeft:.5+'rem'}} >
          Nota
        </Typography>   
        <FormControl component="fieldset" style={{width:30+'rem'}}>    
          <textarea id="Descripcion-TextArea" name="Descripcion" rows="5"
            cols="100" placeholder="Nota" style={{width: 30+"rem",borderRadius:3+'px'}} 
            value={Descripcion} onChange={onChangeDesc} 
          />
        </FormControl>
      </Box>
    </form>
  </Modal>
  );
}
 
export default NuevaBitacora;